import IMapSzukajServiceConfig from '~/components/map/types/IMapSzukajServiceConfig';
import { BloczekMarker } from '~/components/map/types/marker/BloczekMarker';

const getMarkerZIndex = (marker: BloczekMarker, { markersInnerState }: IMapSzukajServiceConfig): number => {
  const isActive: boolean = marker.Id === markersInnerState.activeMarker?.Id;
  const isPromowany: boolean = marker.Promowane;

  if (isActive) return 1000003;

  if (isPromowany) return 1000002;

  return 1000001;
};
export default getMarkerZIndex;
